import { useArenaMural } from 'modules/arena/mural/useArenaMural';
import { StatTile } from 'shared/components/ui/StatTile';
import { PillTabs } from 'shared/components/ui/PillTabs';
import { CreateAnnouncementCard } from 'modules/arena/mural/components/CreateAnnouncementCard';
import { ArenaPostCard } from 'modules/arena/mural/components/ArenaPostCard';
import { MURAL_FILTERS } from 'modules/arena/mural/content';
import { AsyncSection } from 'shared/components/ui/LoadingState';
import { Skeleton, SkeletonButton, SkeletonCard, SkeletonPills, SkeletonPostCard, SkeletonStatGrid } from 'shared/components/ui/Skeleton';

export function ArenaMuralPage() {
  const {
    posts,
    isLoading,
    error,
    filteredPosts,
    filter,
    setFilter,
    announcementText,
    setAnnouncementText,
    publishAnnouncement,
    removePost,
    restorePost,
    resolveReport,
  } = useArenaMural();

  const activeCount = posts.filter((post) => post.state === 'ativo').length;
  const openRachasCount = posts.filter((post) => post.state === 'ativo' && post.kind === 'racha').length;
  const reportedCount = posts.filter((post) => post.state === 'ativo' && post.reportCount > 0).length;
  const removedCount = posts.filter((post) => post.state === 'removido').length;

  return (
    <div className="mx-auto w-full max-w-3xl flex-1 p-6">
      <h1 className="font-heading text-xl font-bold text-ink">Mural</h1>
      <p className="text-sm text-ink-secondary">
        Avisos oficiais, rachas e moderação do feed da unidade.
      </p>

      <AsyncSection
        isLoading={isLoading}
        error={error}
        loadingLabel="Carregando mural..."
        skeleton={
          <>
            <SkeletonStatGrid />
            <SkeletonCard className="mt-6">
              <Skeleton className="h-4 w-40" />
              <Skeleton className="mt-2 h-3 w-4/5" />
              <Skeleton className="mt-4 h-20 w-full rounded-lg" />
              <SkeletonButton className="mt-4 w-32" />
            </SkeletonCard>
            <SkeletonPills className="mt-6" widths={[64, 72, 64, 104, 96]} />
            <div className="mt-4 flex flex-col gap-4">
              <SkeletonPostCard withAction={false} />
              <SkeletonPostCard withAction={false} />
            </div>
          </>
        }
      >
          <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
            <StatTile label="Publicações ativas" value={String(activeCount)} />
            <StatTile label="Rachas abertos" value={String(openRachasCount)} />
            <StatTile label="Denúncias pendentes" value={String(reportedCount)} />
            <StatTile label="Removidas (histórico)" value={String(removedCount)} />
          </div>

          <div className="mt-6">
            <CreateAnnouncementCard
              text={announcementText}
              onChangeText={setAnnouncementText}
              onPublish={publishAnnouncement}
            />
          </div>

          <div className="mt-6">
            <PillTabs options={MURAL_FILTERS} value={filter} onChange={setFilter} />
          </div>

          <div className="mt-4 flex flex-col gap-4">
            {filteredPosts.length === 0 ? (
              <p className="text-sm text-ink-secondary">Nenhuma publicação nesse filtro.</p>
            ) : (
              filteredPosts.map((post) => (
                <ArenaPostCard
                  key={post.id}
                  post={post}
                  onRemove={removePost}
                  onRestore={restorePost}
                  onResolveReport={resolveReport}
                />
              ))
            )}
          </div>
      </AsyncSection>
    </div>
  );
}
